import React, { useState, useEffect } from 'react';
import './MatchesList.css'; // Import your CSS file

import { useNavigate } from 'react-router-dom';

import moment from 'moment';

import useAxios from './useAxios';

const MatchesList = () => {  
    const navigate = useNavigate();
    const [axios] = useAxios(true);

    const [matches, setMatches] = useState([]);
    const [showArchived, setShowArchived] = useState(false);
    const [statusFilter, setStatusFilter] = useState('all');

    const getStatusText = (status) => {
        switch (status) {
            case 0: return 'Pending';
            case 1: return 'Started';
            case 2: return 'Finished';
            default: return 'Unknown';
        }
    };

    useEffect(() => {
      axios.get('matches', setMatches);
    }, []);

    const handleArchiveMatch = (matchId) => {
      const matchToUpdate = matches.find(m => m.id === matchId);
      const updatedMatch = { ...matchToUpdate, isArchived: !matchToUpdate.isArchived, competition: null };
      
      axios.post(`match/${matchId}`, updatedMatch, () => {
        // Refresh the matches list after successful archive
        axios.get('matches', setMatches);
      });
    };

    const filteredMatches = matches
        .filter(match => showArchived || !match.isArchived)
        .filter(match => statusFilter === 'all' || match.status === parseInt(statusFilter))
        .sort((a, b) => b.id - a.id);

  return (
    <div className="matches-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: '0' }}>Matches</h2>
        <div className="matches-filters" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <label>
            <input
              type="checkbox"
              checked={showArchived}
              onChange={(e) => setShowArchived(e.target.checked)}
              className="custom-checkbox"
            />
            <span className="label-text">Show Archived Matches</span>
          </label>
          <label>
            <span className="label-text">Status: </span>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{ marginLeft: '5px', padding: '2px 8px' }}
            >
              <option value="all">All</option>
              <option value="0">Pending</option>
              <option value="1">Started</option>
              <option value="2">Finished</option>
            </select>
          </label>
        </div>
      </div>
      <table className="matches-table">
        <thead>
            <tr>
                <th>Name</th>
                <th>Date/Time</th>
                <th>Home</th>
                <th>Away</th>
                <th>Competition</th>
                <th>Table</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            <tr key="new">
                <td></td>
                <td>
                    <button className="edit-button" onClick={() => navigate('/match/new')}>New</button>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            {filteredMatches.map((match) => (
            <tr key={match.id}>
                <td>{match.name}</td>
                <td>{match.dateTime ? moment(match.dateTime).format('DD MMM YY HH:mm') : ''}</td>
                <td>
                    {match.home?.player?.name && (
                        <div>
                            <strong>{match.home.player.name}</strong>
                            {match.home.player.handicap && ` (${match.home.player.handicap})`}
                            {match.home.score !== undefined && ` - ${match.home.score}`}
                        </div>
                    )}
                </td>
                <td>
                    {match.away?.player?.name && (
                        <div>
                            <strong>{match.away.player.name}</strong>
                            {match.away.player.handicap && ` (${match.away.player.handicap})`}
                            {match.away.score !== undefined && ` - ${match.away.score}`}
                        </div>
                    )}
                </td>
                <td>{match.competition?.name}</td>
                <td>{match.table?.name}</td>
                <td>{getStatusText(match.status)}</td>
                <td>
                    <button className="edit-button" onClick={() => navigate('/match/' + match.id)}>Edit</button>
                    <button 
                        className={match.isArchived ? "archive-button archived" : "archive-button"} 
                        onClick={() => handleArchiveMatch(match.id)}
                    >
                        {match.isArchived ? 'Unarchive' : 'Archive'}
                    </button>
                </td>
            </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default MatchesList;
